<template>
  <div>
    <div class="row items-center">
      <h2
        v-if="showTitle"
        class="col q-mt-sm"
      >
        Payments
      </h2>

      <div
        v-if="split"
        class="col-auto text-caption"
      >
        <div v-if="splitRatio">
          {{ splitRatio }}x
        </div>
        <i18n-n
          v-else
          :value="splitAmount"
          format="currency"
          scope="global"
        />
      </div>
      <slot name="actions" />
    </div>

    <q-list
      v-if="showPaymentList"
      bordered
      separator
    >
      <q-item
        v-if="!$register"
        class="bg-responsive-grey-3"
      >
        <q-item-section avatar>
          <q-avatar
            icon="fas fa-gift-card"
            text-color="responsive"
          />
        </q-item-section>

        <q-item-section :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'">
          {{ $t('payment.actions.payWithMethod', { method: $tc('giftCard.giftCard', 1) }) }}
        </q-item-section>
      </q-item>
      <slot name="payment-line-items" />
    </q-list>
  </div>
</template>

<script>

export default {
  name: 'PaymentList',
  props: {
    splitAmount: {
      type: Number,
      required: false,
      default: 0
    },
    splitRatio: {
      type: Number,
      required: false,
      default: 0
    },
    split: {
      type: Boolean,
      required: false,
      default: false
    },
    showPaymentList: {
      type: Boolean,
      required: false,
      default: true
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true
    },
    paymentConnectorPaymentInProgress: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  color: var(--q-primary);
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1em;
}
</style>
